export const hasRecaptchaDisabled = (): boolean => {
  const isRecaptchaDisabled = process.env.GATSBY_RECAPTCHA_DISABLE
  return isRecaptchaDisabled === 'true' || isRecaptchaDisabled === '1' || isRecaptchaDisabled === 'yes';
};

export const RECAPTCHA_DISABLED = hasRecaptchaDisabled();
